import React, { FC } from 'react'
import ImgUtil from '../../../../utils/img.utils'
import { internalLinkHandler } from '../../../../utils/link.utils'
import formatInlineCode from '../../../../utils/shortTextFormatting'
import Button from '../../button'
import Typography from '../../typography'
import WrapperImage from '../../wrapperImage'

type Props = {
  quoteData: any
}

export const QuoteBlock: FC<Props> = ({ quoteData }) => {
  const quoteCtaText = quoteData.quoteCta?.text || ''
  const externalUrl = quoteData.quoteCta?.externalUrl || ''
  const internalLink = quoteData.quoteCta?.internalLink || ''
  const imgAltText = quoteData.image?.altText || ''
  const imgUrl = quoteData.image?.image?.file?.url || ''

  return (
    <div className="Quote__Inner">
      <div className="Quote__Image-Container">
        <WrapperImage
          loading="lazy"
          className="Quote__Image"
          src={ImgUtil.getResizedImageUrl(imgUrl, 'width=282')}
          alt={imgAltText}
          threshold={650}
        />
      </div>

      <div className="Quote__Text">
        {quoteData.body && (
          <Typography type="leadXS">{formatInlineCode(quoteData.body)}</Typography>
        )}

        {quoteData.authorName && (
          <Typography className="Quote__Author" type="label">
            {quoteData.authorName}
          </Typography>
        )}

        {quoteData.authorTitle && quoteData.company && (
          <Typography
            className="Quote__Title"
            type="bodyXS">{`${quoteData.authorTitle}, ${quoteData.company}`}</Typography>
        )}

        {quoteCtaText && (externalUrl || internalLink) && (
          <Button
            icon={true}
            href={internalLink ? internalLinkHandler(internalLink) : externalUrl}
            text={quoteCtaText}
            type="text-link"
            size="small"
            className="Quote__CTA"
            theme={quoteData.theme === 'Dark' ? 'dark' : 'light'}
          />
        )}
      </div>
    </div>
  )
}
